'use strict';
import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';
import _ from 'lodash';

import cellTemplateHtmlUrl from '../views/cellTemplate.html';
import inventoryAvailableEventsHtmlUrl from '../views/inventoryAvailableEvents.html';

angular.module('inventorycalendar.ctrls', [])
    .controller('InventoryCalendarController', InventoryCalendarController)
    .controller('InventoryAvailableEventsModalController', InventoryAvailableEventsModalController);

InventoryCalendarController.$inject = ['$scope', '$ioAlert', '$rootScope', '$timeout', '$sce', '$modal', 'UserService', 'ClusterService', 'DateRangeService', 'PageNumberService', 'InventoryCalendarService', 'ModalService'];

function InventoryCalendarController($scope, $ioAlert, $rs, $timeout, $sce, $modal, UserService, ClusterService, DateRangeService, PageNumberService, InventoryCalendarService, ModalService) {

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $scope.property = [];
        $scope.section = [];
        $scope.adsize = [];
        fetchProperties(ClusterService.clusterIds[0]);
        fetchAdSizeSlots(ClusterService.clusterIds[0]);
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.timespanClicked = function(calendarDate) {
        return false;
    };

    function fetchProperties(clusterId) {
        InventoryCalendarService.getWebsitePlacements(clusterId).then(function(success) {
            $scope.properties = InventoryCalendarService.websitePlacements;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function fetchSections(propertyName) {
        InventoryCalendarService.getWebsiteSections(propertyName).then(function(success) {
            if (InventoryCalendarService.websiteSections) {
                let currentSections = [...$scope.sections];
                _.each(InventoryCalendarService.websiteSections, function(section) {
                    if (!_.find(currentSections, {id: section.id})) {
                        currentSections.push(section);
                    }
                });
                $scope.sections = currentSections;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function fetchAdSizeSlots(clusterId) {
        InventoryCalendarService.getSlotTypes().then(function(success) {
            $scope.adSizes = InventoryCalendarService.slotTypes;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    //Generate the data types array for the data types select2
    function genSelectData(data) {
        return $.map(data, function(datum) {
            return { id: datum.id, text: datum.lookup_value };
        });
    }

    function genSlotSelectData(data) {
        return $.map(data, function(datum) {
            return { id: datum.id, text: datum.name };
        });
    }

    function genCalItems(data) {
        return $.map(data, function(datum) {
            var type = 'important';
            var totalBudget = datum.total_budget ? datum.total_budget : "";
            return {
                cssClass: 'custom-entry',
                data: {
                    line_item_id: datum.line_item_id,
                    name: datum.name,
                    client_name: datum.client_name,
                    order_id: datum.order_id,
                    line_item_start_date: datum.line_item_start_date,
                    line_item_end_date: datum.line_item_end_date,
                    line_item_status: datum.line_item_status,
                    total_budget: datum.total_budget,
                    salesperson_name: datum.salesperson_name,
                    website: datum.website,
                    section: datum.section,
                    ad_size: datum.ad_size
                },
                type: type,
                reserved: 'open',
                startsAt: moment(datum.booking_date).toDate(),
                endsAt: moment(datum.booking_date).toDate(),
                draggable: false,
                resizeable: false,
                editable: false,
                deletable: false
            }
        })
    }

    function genCalItem(day, data, altType) {
        var type = 'important';
        return {
            cssClass: 'custom-entry',
            data: data,
            type: altType,
            reserved: 'open',
            slot_date: day,
            startsAt: moment(day).toDate(),
            endsAt: moment(day).toDate(),
            draggable: false,
            resizeable: false,
            editable: false,
            deletable: false
        }
    }

    //Validate that all needed user selections are selected before trying to fetch data
    function validateCalActivation(trigger) {
        var watchers = ['property', 'section'];
        var isEverythingSet = true;
        for (var i = 0; i < watchers.length; i++) {
            if (watchers[i] !== trigger) {
                if (!$scope[watchers[i]]) {
                    isEverythingSet = false;
                    break;
                }
            }
        }
        return isEverythingSet;
    }

    function fetchReservedCal(websiteId, calendarDate, hasSlotDeleted) {
        var propertyIds = [];
        if (websiteId) {
            propertyIds.push(websiteId);
        } else if ($scope.property) {
            for (var i = 0; i < $scope.property.length; i++) {
                propertyIds.push($scope.property[i].id);
            }
        }
        var sectionIds = [];
        if ($scope.section) {
            for (var j = 0; j < $scope.section.length; j++) {
                sectionIds.push($scope.section[j].id);
            }
        }
        var addSizes = [];
        if ($scope.adsize) {
            for (var x = 0; x < $scope.adsize.length; x++) {
                addSizes.push($scope.adsize[x].id);
            }
        }
        if (propertyIds.length > 0 && sectionIds.length > 0) {
            var startDate = moment($scope.calendarDay).format('YYYY-MM') + "-00";
            var endDate = moment(moment($scope.calendarDay).endOf('month')).format('YYYY-MM-DD');
            for (var webIndex = 0, webLen = propertyIds.length; webIndex < webLen; webIndex++) {
                InventoryCalendarService.reservedSlotsForWebsiteAndSectionsAndPeriod(propertyIds[webIndex], sectionIds, addSizes, startDate, endDate).then(function(response) {
                    if (hasSlotDeleted === true) {
                        if (websiteId && calendarDate) {
                            var calendar_date = moment(calendarDate).format('YYYY-MM-DD');
                            var eventIndex = _.findIndex($scope.events[websiteId], { type: 'warning', slot_date: calendar_date });
                            if (eventIndex >= 0) {
                                $scope.events[response.website_id].splice(eventIndex, 1);
                            }
                        }
                    }
                    if (response.slot_reservations && response.slot_reservations.length > 0) {
                        var slot_bookings = _.groupBy(response.slot_reservations, "reservation_date");
                        for (var day in slot_bookings) {
                            var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'warning', slot_date: day });
                            if (eventIndex >= 0) {
                                $scope.events[response.website_id][eventIndex] = genCalItem(day, slot_bookings[day], 'warning');
                            } else {
                                $scope.events[response.website_id].push(genCalItem(day, slot_bookings[day], 'warning'));
                            }
                        }
                    }
                });
                InventoryCalendarService.getAvailableSlotsForWebsiteAndSectionsAndPeriod(propertyIds[webIndex], sectionIds, addSizes, startDate, endDate).then(function(response) {
                    if (response.website_id && calendarDate) {
                        var calendar_date = moment(calendarDate).format('YYYY-MM-DD');
                        var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'success', slot_date: calendar_date });
                        if (eventIndex >= 0) {
                            $scope.events[response.website_id].splice(eventIndex, 1);
                        }
                    }
                    if (!$scope.events[response.website_id]) {
                        $scope.events[response.website_id] = [];
                    }
                    if (response.slot_bookings && response.slot_bookings.length > 0) {
                        var slot_bookings = _.groupBy(response.slot_bookings, "available_date");
                        for (var day in slot_bookings) {
                            var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'success', slot_date: day });
                            if (eventIndex >= 0) {
                                $scope.events[response.website_id][eventIndex] = genCalItem(day, slot_bookings[day], 'success');
                            } else {
                                $scope.events[response.website_id].push(genCalItem(day, slot_bookings[day], 'success'));
                            }
                        }
                    }
                });
            }
        }
    }

    function fetchAndSetCal() {
        var propertyIds = [];
        if ($scope.property) {
            for (var i = 0; i < $scope.property.length; i++) {
                propertyIds.push($scope.property[i].id);
            }
        }

        var sectionIds = [];
        if ($scope.section) {
            for (var j = 0; j < $scope.section.length; j++) {
                sectionIds.push($scope.section[j].id);
            }
        }

        var addSizes = [];
        if ($scope.adsize) {
            for (var x = 0; x < $scope.adsize.length; x++) {
                addSizes.push($scope.adsize[x].id);
            }
        }

        if (propertyIds.length > 0 && sectionIds.length > 0) {
            var startDate = moment($scope.calendarDay).format('YYYY-MM') + "-01";
            var endDate = moment(moment($scope.calendarDay).endOf('month')).format('YYYY-MM-DD');
            $scope.events = {};
            for (var webIndex = 0, webLen = propertyIds.length; webIndex < webLen; webIndex++) {
                $scope.events[propertyIds[webIndex]] = [];
                InventoryCalendarService.getAvailableSlotsForWebsiteAndSectionsAndPeriod(propertyIds[webIndex], sectionIds, addSizes, startDate, endDate).then(function(response) {
                    if (!$scope.events[response.website_id]) {
                        $scope.events[response.website_id] = [];
                    }
                    var monthNav = 1;
                    var monthEnd = moment(moment($scope.calendarDay).endOf('month')).format('DD');
                    while (monthNav<monthEnd && monthNav<=31){
                        if(monthNav<10){
                            var day = moment($scope.calendarDay).format('YYYY-MM') + "-0" + monthNav;
                        }else {
                            var day = moment($scope.calendarDay).format('YYYY-MM') + "-" + monthNav;
                        }
                        var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'success', slot_date: day });
                        if (eventIndex >= 0) {
                            $scope.events[response.website_id].splice(eventIndex, 1);
                        }
                        monthNav++;
                    }
                    if (response.slot_bookings && response.slot_bookings.length > 0) {
                        var slot_bookings = _.groupBy(response.slot_bookings, "available_date");
                        for (var day in slot_bookings) {
                            var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'success', slot_date: day });
                            if (eventIndex >= 0) {
                                $scope.events[response.website_id][eventIndex] = genCalItem(day, slot_bookings[day], 'success');
                            } else {
                                $scope.events[response.website_id].push(genCalItem(day, slot_bookings[day], 'success'));
                            }
                        }
                    }
                });
                InventoryCalendarService.getBookedSlotsForWebsiteAndSectionsAndPeriod(propertyIds[webIndex], sectionIds, addSizes, startDate, endDate).then(function(response) {
                    var monthNav = 1;
                    var monthEnd = moment(moment($scope.calendarDay).endOf('month')).format('DD');
                    while (monthNav<monthEnd && monthNav<=31){
                        if(monthNav<10){
                            var day = moment($scope.calendarDay).format('YYYY-MM') + "-0" + monthNav;
                        }else {
                            var day = moment($scope.calendarDay).format('YYYY-MM') + "-" + monthNav;
                        }
                        var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'important', slot_date: day });
                        if (eventIndex >= 0) {
                            $scope.events[response.website_id].splice(eventIndex, 1);
                        }
                        monthNav++;
                    }
                    if (response.slot_bookings && response.slot_bookings.length > 0) {
                        var slot_bookings = _.groupBy(response.slot_bookings, "booking_date");
                        for (var day in slot_bookings) {
                            var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'important', slot_date: day });
                            if (eventIndex >= 0) {
                                $scope.events[response.website_id][eventIndex] = genCalItem(day, slot_bookings[day], 'important');
                            } else {
                                $scope.events[response.website_id].push(genCalItem(day, slot_bookings[day], 'important'));
                            }
                        }
                    }
                });
                InventoryCalendarService.reservedSlotsForWebsiteAndSectionsAndPeriod(propertyIds[webIndex], sectionIds, addSizes, startDate, endDate).then(function(response) {
                    var monthNav = 1;
                    var monthEnd = moment(moment($scope.calendarDay).endOf('month')).format('DD');
                    while (monthNav<monthEnd && monthNav<=31){
                        if(monthNav<10){
                            var day = moment($scope.calendarDay).format('YYYY-MM') + "-0" + monthNav;
                        }else {
                            var day = moment($scope.calendarDay).format('YYYY-MM') + "-" + monthNav;
                        }
                        var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'warning', slot_date: day });
                        if (eventIndex >= 0) {
                            $scope.events[response.website_id].splice(eventIndex, 1);
                        }
                        monthNav++;
                    }
                    if (response.slot_reservations && response.slot_reservations.length > 0) {
                        var slot_bookings = _.groupBy(response.slot_reservations, "reservation_date");
                        for (var day in slot_bookings) {
                            var eventIndex = _.findIndex($scope.events[response.website_id], { type: 'warning', slot_date: day });
                            if (eventIndex >= 0) {
                                $scope.events[response.website_id][eventIndex] = genCalItem(day, slot_bookings[day], 'warning');
                            } else {
                                $scope.events[response.website_id].push(genCalItem(day, slot_bookings[day], 'warning'));
                            }
                        }
                    }
                });
            }
            $scope.message = '';
            $timeout(function() {
                $scope.redraw = true;
                $scope.$apply();
                $scope.redraw = false;
            });
        }

    }

    function showInventoryModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    function init() {
        $scope.properties = [];
        $scope.sections = [];
        $scope.adSizes = [];
        $scope.prop = null;
        $scope.property = null;
        $scope.section = null;
        $scope.adsize = null;
        $scope.redraw = false;

        ClusterService.initCluster($rs.userRole, 'singleSelectWithAllClusters').then(function(data) {
            if (ClusterService.pageProperties.selectedClusters.enable_inventory_calendar == 0) {
                $scope.message = 'This Business Unit does not have Inventory Calendar enabled.';
            }
        });

        DateRangeService.init();

        //These variables MUST be set as a minimum for the calendar to work
        $scope.calendarView = 'month';
        $scope.calendarDay = new Date();
        $scope.events = {};

        //Calendar templateUrl
        $scope.cellTemplate = $sce.getTrustedResourceUrl(cellTemplateHtmlUrl);

        //Disable calendar by default until inventory selections have been made
        $scope.calendarTitle = $scope.calendarDay;

        $scope.onEventClicked = function(calendarEvent, calendarDate) {
            if (calendarEvent && calendarEvent.type) {
                if (calendarEvent.type == "important") {
                    showInventoryModal('inventoryEvents', { inventory: calendarEvent.data, day: calendarDate, property: $scope.property[$scope.__default__currentPage - 1] }).result.then(function(stuff) {
                        //do nothing
                    }, function(cancel) {
                        //still do nothing
                    });
                } else if (calendarEvent.type == "success") {
                    $modal.open({
                        controller: 'InventoryAvailableEventsModalController',
                        templateUrl: inventoryAvailableEventsHtmlUrl,
                        backdrop: 'static',
                        size: 'md',
                        windowClass: 'smooth modal-overflow in',
                        resolve: {
                            data: function() {
                                return {
                                    inventory: calendarEvent.data, 
                                    day: calendarDate, 
                                    property: $scope.property[$scope.__default__currentPage - 1]
                                };
                            }
                        },
                    }).result.then(function(response) {
                        fetchReservedCal(response.website_id, calendarDate);
                    }, function(cancel) {
        
                    });
                } else if (calendarEvent.type == "warning") {
                    showInventoryModal('inventoryReservedEvents', { inventory: calendarEvent.data, day: calendarDate, property: $scope.property[$scope.__default__currentPage - 1] }).result.then(function(response) {
                        fetchReservedCal(response.website_id, calendarDate, true);
                    }, function(cancel) {
                        //still do nothing
                    });
                }

            }
        }

        //calendar overlay placeholder message
        $scope.message = 'Please select inventory criteria.';

        //Gen placeholder select2 menus
        $scope.propertySelectOptions = { data: [], width: '100%', multiple: true, placeholder: 'Please select a property.' };
        $scope.sectionSelectOptions = { data: [], width: '100%', multiple: true, placeholder: 'Please select a selection.' };
        $scope.adSizeSelectOptions = { data: [], width: '100%', multiple: true, placeholder: 'Please select an ad size.' };

        $scope.updateCalendar = function(newPageNumber, oldPageNumber) {
            if ($scope.property && $scope.property.length) {
                $scope.calendarTitle = $scope.property[$scope.__default__currentPage - 1].text + ': ' + moment($scope.calendarDay).format('MMMM YYYY');
            }
        };

        $scope.$watch('properties', function(nV, oV) {
            if (nV && nV !== oV) {
                $scope.propertySelectOptions = { data: genSelectData($scope.properties), width: '100%', multiple: true, placeholder: 'Please select a property.' };
            }
        });

        $scope.$watch('property', function(nV, oV) {
            PageNumberService.setPages($scope.property);
            $scope.prop = $scope.property;
            if ($scope.property && $scope.property.length) {
                $scope.calendarTitle = $scope.property[$scope.property.length - 1].text + ': ' + moment($scope.calendarDay).format('MMMM YYYY');
                fetchSections($scope.property[$scope.property.length - 1].text);
            }
            if (nV && nV !== oV) {
                if (validateCalActivation('property')) {
                    fetchAndSetCal();
                }
            }
        });

        $scope.$watch('calendarDay', function(nV, oV) {
            if ($scope.property && $scope.property.length) {
                $scope.calendarTitle = $scope.property[$scope.__default__currentPage - 1].text + ': ' + moment(nV).format('MMMM YYYY');
            }
            if (nV && nV !== oV) {
                if (validateCalActivation('property')) {
                    fetchAndSetCal();
                }
            }
        });

        $scope.$watch('sections', function(nV, oV) {
            if (nV && nV !== oV) {
                if (nV.length === 0) {
                    $scope.message = 'Please select inventory criteria.';
                }
                $scope.sectionSelectOptions = { data: genSelectData($scope.sections), width: '100%', multiple: true, placeholder: 'Please select a selection.' };
            }
        });

        $scope.$watch('section', function(nV, oV) {
            if (nV && nV !== oV) {
                if (nV.length === 0) {
                    $scope.events = [];
                    $scope.message = 'Please select inventory criteria.';
                } else {
                    if (validateCalActivation('section')) {
                        fetchAndSetCal();
                    }
                }
            }
        });

        $scope.$watch('adSizes', function(nV, oV) {
            if (nV && nV !== oV) {
                $scope.adSizeSelectOptions = { data: genSlotSelectData($scope.adSizes), width: '100%', multiple: true, placeholder: 'Please select an ad size.' };
            }
        });

        $scope.$watch('adsize', function(nV, oV) {
            if (nV && nV !== oV || oV && !nV) {
                if (nV.length === 0 && !$scope.section) {
                    $scope.events = [];
                    $scope.message = 'Please select inventory criteria.';
                } else {
                    if (validateCalActivation('adsize')) {
                        fetchAndSetCal();
                    }
                }
            }
        });

        var getClients = function() {
            UserService.getClients(ClusterService.clusterIds).then(function(success) {
                $scope.clients = UserService.clients;
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };
        
        var init = function(){
            getClients();
        }
        init();
    }
}

InventoryAvailableEventsModalController.$inject = ['$scope', '$modalInstance', '$q', 'data', 'InventoryCalendarService', '$ioAlert', 'ClusterService', 'UserService', '$filter'];

function InventoryAvailableEventsModalController($scope, $modalInstance, $q, data, InventoryCalendarService, $ioAlert, ClusterService, UserService, $filter) {
    $scope.property = data.property;
    $scope.day = moment(data.day).format('MM/DD/YYYY');
    $scope.inventoryData = data.inventory;
    $scope.clientObj = {};
    $scope.pageObj = {
        perPageOptions: [10, 25, 50, 100],
        maxSize: 2,
        perPage: 10,
        currentPage: 1,
        totalCount: 0,
        orderBy: 'section_name',
        reverse: true,
        startIndex: 1,
        endIndex: 1,
        limitIndex: 0,
        search: ''
    };


    /*
     * Handle counts for indexes
    */
    var calculate = function() {
        if ($scope.inventoryData && $scope.inventoryData.length) {
            var ordering = "asc";
            if ($scope.pageObj.reverse) {
                ordering = "desc";
            }
            var filterEvents = $filter('filter')($scope.inventoryData, $scope.pageObj.search);
            filterEvents = _.orderBy(filterEvents, $scope.pageObj.orderBy, ordering);
            $scope.pageObj.totalCount = filterEvents.length;
            $scope.pageObj.startIndex = Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
            $scope.pageObj.endIndex = Math.min($scope.pageObj.currentPage * $scope.pageObj.perPage);
            if ($scope.pageObj.totalCount != 0 && $scope.pageObj.endIndex > $scope.pageObj.totalCount) {
                $scope.pageObj.endIndex = $scope.pageObj.totalCount;
            }
            var begin = (($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage),
                end = begin + $scope.pageObj.perPage;
            $scope.filteredEvents = filterEvents.slice(begin, end);

        } else {
            $scope.filteredEvents = [];
            $scope.pageObj = {
                perPageOptions: [10, 25, 50, 100],
                maxSize: 2,
                perPage: 50,
                currentPage: 1,
                totalCount: 0,
                orderBy: 'id',
                reverse: true,
                startIndex: 1,
                endIndex: 1,
                limitIndex: 0,
                search: ''
            };
        }

    };

    $scope.$watch('pageObj.currentPage', function() {
        calculate();
    });
    $scope.$watch('pageObj.perPage', function() {
        calculate();
    });

    $scope.$watch('pageObj.search', function() {
        calculate();
    });
    
    $scope.addSlotReservation = function(inventoryObj, clientId) {
        InventoryCalendarService.addSlotReservation(inventoryObj.slot_id, inventoryObj.available_date, clientId).then(function(response) {
            if (response.errors) {
                $ioAlert.show('Error!', response.errors[0], 'error');
            } else {
                response.slotReservation.website_id = inventoryObj.website_id;
                response.slotReservation.calendar_date = data.day;
                $ioAlert.show('', 'Slot reserved successfully', 'success');
                $modalInstance.close(response.slotReservation);
            }
        });
    };

    $scope.closeModal = function() {
        $modalInstance.dismiss();
    };

    var getClients = function() {
        UserService.getClients(ClusterService.clusterIds).then(function(success) {
            $scope.clients = UserService.clients;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var init = function() {
        getClients();
    };

    init();
}